const initialState = true;

export default (state = initialState, action) => {
    switch (action.type) {
        case "HAS_ACCESS_UPDATED":
            return action.data;
        default:
            return state;
    }
}

